export * from "./Badge.settings";
